// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__3uEhe","animate-preloader":"Preloader_animate-preloader__2ekUv"};